module.exports = __webpack_public_path__ + "img/ZB52_12.128e8db0.jpg";